var exports = {
  "uW": "x61f99309--4fca95--section",
  "pq": "x61f99309--4fca95--info",
  "jf": "x61f99309--4fca95--right-content",
};

module.exports = exports;
